module.exports = __webpack_public_path__ + "img/icon-data-application-active.e1b342fa.svg";